import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import '../../styles/CommonModal.css';

const backdropVariants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1 },
  exit: { opacity: 0 },
};

const modalVariants = {
  hidden: { opacity: 0, y: -50 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.3, ease: 'easeOut' },
  },
  exit: {
    opacity: 0,
    y: -50,
    transition: { duration: 0.2, ease: 'easeIn' },
  },
};

const CommonModal = ({ isOpen, onClose, children, elId, closeOnBackdropClick = true, closeOnEscape = true, backdropClassName = '' }) => {
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape'  && closeOnEscape) onClose();
    };
    if (isOpen) {
      window.addEventListener('keydown', handleEsc);
    }
    return () => window.removeEventListener('keydown', handleEsc);
  }, [isOpen, onClose, closeOnEscape]);

  return (
    <AnimatePresence>
      {isOpen && (
        <>
          <motion.div
            className={`modal-backdrop ${backdropClassName}`}
            variants={backdropVariants}
            initial="hidden"
            animate="visible"
            exit="exit"
            onClick={closeOnBackdropClick ? onClose : undefined}
          />

          <motion.div
            id={elId}
            className="modal modalStyle showModal fadeModal"
            variants={modalVariants}
            initial="hidden"
            animate="visible"
            exit="exit"
            onClick={closeOnBackdropClick ? onClose : undefined}
            style={{ display: 'block' }}
          >
            <motion.div
              className="modal-dialog modal-dialog-centered modal-xl"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="modal-content">{children}</div>
            </motion.div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};

export default CommonModal;
